<template>
  <v-container
    id="container-checkout"
    fluid
    fill-height
    pa-0
    ma-0
    class="test_green"
  >
    <v-toolbar v-if="isReady">
      <v-btn
        icon
        @click="$router.push({ name: 'menu', params: { tableId: tableId } })"
      >
        <v-icon v-text="'mdi-arrow-left'" />
      </v-btn>

      <v-toolbar-title>Back to discovery page</v-toolbar-title>
      <v-spacer></v-spacer>
      <Language />
      <div v-if="$store.getters.checkAuth" class="px-2">
        <ProfileCustomer />
      </div>
    </v-toolbar>
    <SpinnerLoader v-if="!isReady" />
  </v-container>
</template>

<script>
export default {
  name: "CheckoutQuick",
  data: () => ({
    tableId: null,
  }),
  computed: {
    isReady: {
      get() {
        return this.$store.getters.deliveryServicesList.length > 0;
      },
      set(val) {
        return !!val;
      },
    },
  },
  mounted() {
    this.tableId = this.$route.params.tableId;
  },
};
</script>

<style scoped></style>
